import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import "../../css/pages/contactUsPage.css";
import "../../css/pages/homePage.css";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";

const ContactUsPage = () => {
  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
    consent: false,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // clear field error as user types
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const next = {};

    if (!form.name.trim()) next.name = "Name is required";
    if (!form.number.trim()) next.number = "Number is required";
    if (!form.email.trim()) next.email = "Email is required";
    if (!form.message.trim()) next.message = "Message is required";
    if (!form.consent)
      next.consent = "Please confirm you have read the privacy policy";

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  /**
   * Runs automatically on Google Form submit (installable trigger).
   * Sends the form response to your Node endpoint.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!validate()) return;

      const to = process.env.REACT_APP_ADVISER_EMAIL;

      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        number: form.number.trim(),
        message: form.message.trim(),
        to: (to || "").trim(),
      };

      const url = `${process.env.REACT_APP_SERVER_URL}/send-adviser-contact-confirmation`;

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errText = await res.text();
        console.log("API error:", errText);
        return;
      }

      // optional: success UI / reset
      setForm({
        name: "",
        number: "",
        email: "",
        message: "",
        consent: false,
      });

      setErrors({});
      console.log("Sent successfully");
    } catch (err) {
      console.log("handleSubmit error:", err);
    }
  };
  return (
    <div className="primary-container">
      <div className="column contact-header">
        <div className="nav primary">contact</div>
        <h2 className="secondary">
          Contact <span style={{ fontStyle: "italic" }}>Us</span>
        </h2>
        <div className="divider primary align-left" />
      </div>
      <section className="contact-form-wrap">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-row">
            <div className="contact-field">
              <label>Name:</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                className={errors.name ? "has-error" : ""}
              />
              {errors.name ? (
                <span className="error-text">{errors.name}</span>
              ) : null}
            </div>

            <div className="contact-field">
              <label>Number:</label>
              <input
                name="number"
                value={form.number}
                onChange={handleChange}
                className={errors.number ? "has-error" : ""}
              />
              {errors.number ? (
                <span className="error-text">{errors.number}</span>
              ) : null}
            </div>
          </div>

          <div className="contact-field">
            <label>Email:</label>
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              className={errors.email ? "has-error" : ""}
            />
            {errors.email ? (
              <span className="error-text">{errors.email}</span>
            ) : null}
          </div>

          <div className="contact-field">
            <label>Message:</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows={8}
              className={errors.message ? "has-error" : ""}
            />
            {errors.message ? (
              <span className="error-text">{errors.message}</span>
            ) : null}
          </div>

          <div className="contact-consent">
            <input
              type="checkbox"
              name="consent"
              checked={form.consent}
              onChange={handleChange}
              id="consent"
            />
            <label htmlFor="consent">
              *I confirm I have read the{" "}
              <span
                // href="/privacy-policy"
                // target="_blank"
                // rel="noopener noreferrer"
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => navigate("/privacy-policy")}
              >
                privacy policy
              </span>
            </label>
          </div>
          <TertiaryButton
            className="contact-submit"
            type="submit"
            text="SUBMIT"
          />

          {/* <button className="contact-submit" type="submit">
            Submit
          </button> */}
        </form>
        {errors.consent ? (
          <span className="error-text">{errors.consent}</span>
        ) : null}
      </section>
    </div>
  );
};

export default ContactUsPage;
